import { render, staticRenderFns } from "./ReportMobilePackages.vue?vue&type=template&id=68f94441"
import script from "./ReportMobilePackages.vue?vue&type=script&lang=js"
export * from "./ReportMobilePackages.vue?vue&type=script&lang=js"
import style0 from "./ReportMobilePackages.vue?vue&type=style&index=0&id=68f94441&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports